import _styled from "styled-components";
import React from "react";
import { ModalScreen } from "../../ModalScreen/ModalScreen";

var Content = _styled.div.withConfig({
  displayName: "ConfirmModal__Content",
  componentId: "sc-1smj5zv-0"
})(["margin-top:120px;flex:1 1 auto;"]);

var TextInfo = _styled.div.withConfig({
  displayName: "ConfirmModal__TextInfo",
  componentId: "sc-1smj5zv-1"
})([""]);

var Title = _styled.div.withConfig({
  displayName: "ConfirmModal__Title",
  componentId: "sc-1smj5zv-2"
})(["text-align:center;font-size:28px;"]);

var TextDescription = _styled.div.withConfig({
  displayName: "ConfirmModal__TextDescription",
  componentId: "sc-1smj5zv-3"
})(["text-align:center;margin-top:15px;font-size:20px;"]);

var ButtonControlsContainer = _styled.div.withConfig({
  displayName: "ConfirmModal__ButtonControlsContainer",
  componentId: "sc-1smj5zv-4"
})(["display:flex;justify-content:center;"]);

var ButtonControls = _styled.div.withConfig({
  displayName: "ConfirmModal__ButtonControls",
  componentId: "sc-1smj5zv-5"
})(["display:flex;justify-content:space-around;width:270px;margin-top:120px;"]);

export function ConfirmModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      titleText = _ref.titleText,
      contentText = _ref.contentText,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(ModalScreen, {
    isOpen: isOpen,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(TextInfo, null, /*#__PURE__*/React.createElement(Title, null, titleText), contentText && /*#__PURE__*/React.createElement(TextDescription, null, contentText)), /*#__PURE__*/React.createElement(ButtonControlsContainer, null, /*#__PURE__*/React.createElement(ButtonControls, null, children))));
}